import { WhatsAppIcon } from "./icons";
import { WHATSAPP_CHAT_URL } from "../ducks/consts";

// O estilo saiu de um makeStyles (removido no MUI v5) para uma classe em
// App.style.css: o alvo aqui é um <a> puro, não um componente do MUI, então
// `sx` não se aplicaria.
function WhatsAppButton({ whatsapp, message }) {
  if (!whatsapp) {
    return null;
  }

  const encodedMessage = message ? encodeURI(message) : "";
  const whatsAppUrl = `${WHATSAPP_CHAT_URL}/55${whatsapp}?text=${encodedMessage}`;

  return (
    <div className="mt-3 mb-3">
      <a
        rel="noopener noreferrer"
        target="_blank"
        href={whatsAppUrl}
        className="whatsapp-button"
      >
        <WhatsAppIcon className="me-2" />
        WhatsApp
      </a>
    </div>
  );
}

export default WhatsAppButton;
